/**
 * Normalize CRM global search input: trim, strip leading "+", lowercase, and collapse
 * digit-only queries (after removing whitespace) so they match stored phone formats.
 * Lowercasing keeps the search case-insensitive on the backend, which matches on the
 * literal query string.
 */
export function normalizeGlobalCustomerSearchQuery(raw: string): string {
    let s = raw.trim();
    if (s.startsWith('+')) {
        s = s.replace(/^\++/g, '').trim();
    }

    const withoutWhitespace = s.replace(/\s+/g, '');

    if (withoutWhitespace.length > 0 && /^\d+$/.test(withoutWhitespace)) {
        return withoutWhitespace;
    }

    return s.toLowerCase();
}
